import type {
  AddressFilterValue,
  AddressPropertyQuery,
} from "../_shared/_logic/address-table-contract"

export const createDefaultAddressFilters = (): AddressFilterValue => ({
  search: "",
  customerId: "",
  unitQuery: "",
  unitCount: "",
  contactCount: "",
  archiveScope: "ACTIVE",
})

export const parseCountFilter = (value: string) => {
  const trimmed = value.trim()

  if (!trimmed) return undefined

  const parsed = Number(trimmed)

  return Number.isInteger(parsed) && parsed >= 0 ? parsed : undefined
}

export const buildAddressPropertyQuery = ({
  organizationId,
  filters,
  effectiveCustomerId,
  offset,
  limit,
}: {
  organizationId: string
  filters: AddressFilterValue
  effectiveCustomerId: string
  offset: number
  limit: number
}): AddressPropertyQuery | null => {
  if (!organizationId) return null

  const trimmedSearch = filters.search.trim()
  const trimmedUnitQuery = filters.unitQuery.trim()
  const unitCount = parseCountFilter(filters.unitCount)
  const contactCount = parseCountFilter(filters.contactCount)

  return {
    organizationId,
    search: trimmedSearch || undefined,
    customerId: effectiveCustomerId || undefined,
    unitQuery: trimmedUnitQuery || undefined,
    unitCount,
    contactCount,
    archiveScope: filters.archiveScope,
    offset,
    limit,
  }
}
